// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3XHJs","left":"StickyBox_left__1eTDN","right":"StickyBox_right__14fUi"};